import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpHeaders, HttpXsrfTokenExtractor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { Injectable, Injector } from '@angular/core';
import { KEYS } from '../constants/keys';
import * as _ from 'underscore';
import { LoaderService } from '../services/loader.service';

@Injectable({
    providedIn: 'root'
})
export class RequestInterceptor implements HttpInterceptor {
    constructor(private injector: Injector) {}

        intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
            const loaderService = this.injector.get(LoaderService);
            console.log('in interceptor');
            const token: string = localStorage.getItem(KEYS.ACCESS_TOKEN);
            const refreshtoken: string = localStorage.getItem(KEYS.REFRESH_TOKEN);
            let companyId: number = Number(localStorage.getItem(KEYS.COMPANY_ID));
            const clientId: number = Number(localStorage.getItem(KEYS.CLIENT_ID));
            const branchId: number = Number(localStorage.getItem(KEYS.BRANCH_ID));
            // request.params.get() returns the STRING 'false' for an opted-out
            // request, and `!!'false'` is `true` (any non-empty string is
            // truthy) — this silently ignored every caller's attempt to skip
            // the loader via enableLoader=false, since loaderEnabled was
            // always true regardless. Compare the string value directly.
            const enableLoader = request.params.get('enableLoader');
            const loaderEnabled = enableLoader == null || enableLoader !== 'false';
            if(loaderEnabled){
                loaderService.addAPI();
            }
            // finalize runs on complete, error AND unsubscribe (cancelled request),
            // so every addAPI() is always paired with exactly one removeAPI() —
            // a request cancelled by switchMap/takeUntil can no longer leak the counter
            const releaseLoader = () => { if(loaderEnabled){ loaderService.removeAPI(); } };
            if(request.url.includes("login")){
                return next.handle(request).pipe(finalize(releaseLoader));
            }
            let headers= new HttpHeaders();
            headers = headers.set('Access-Control-Allow-Origin', '*');
            if(request.url.includes("/api/open-tracking-output"))
                headers = headers.set('Content-Type', 'application/json');
            headers = headers.set('Access-Control-Allow-Headers', 'Origin, X-Requested-With, Content-Type, Accept');
            if(token!=null){
                headers = headers.set('Authorization', 'Bearer '+token);
            }
            if(refreshtoken!=null){
                headers = headers.set('Authorization', 'Bearer '+refreshtoken);
            }
            if(companyId){
                headers=headers.set('companyId',companyId.toString());
            }
            if(branchId){
                headers=headers.set('branchId',branchId.toString());
            }
            if(clientId){
                headers=headers.set('clientId',clientId.toString());
            }
            if(request?.body?.companyId!=null){
                companyId=request.body.companyId;
            }
            
            const isUploadUrl:boolean = request.url.includes('document-storage/upload') || request.url.includes("wizard/api");
            // uncommented this code after creation of Authorization Flow (also backend LinerMapper,LinerOriginMapper)
            // const body = (request.body && !isUploadUrl && !_.isArray(request.body) ) ? {... request.body, 'clientId': clientId, 'companyId': companyId, 'branchId': branchId}:request.body ;
            const body = (request.body && !isUploadUrl && !_.isArray(request.body) ) ?
                            {... request.body, 'clientId': clientId, 'companyId': companyId, 'branchId': branchId, 'active': true, 'isActive': true, 'activeFlag': true, 'submittedForApproval': false, 'submitedForApproval': false, 'status': request.body?.status == null ? 'APPROVED' : request.body.status}
                                    :request.body ;
            let params;
            if(request.method==="GET"){
                params = request.params.set("clientId",String(clientId)).set("companyId",String(companyId)).set("branchId",String(branchId));
            }
            
            const isDownloadUrl:boolean = request.url.includes('/action') || request.url.includes('report/api/') || request.url.includes("wizard/api");
            const isTextResponse:boolean = request.url.includes('getUserNameById');
            const responseType:"arraybuffer" | "blob" | "json" | "text" = (isTextResponse) ? "text" : (!isDownloadUrl) ? 'json' : 'blob';
            request = request.clone({
                params: params,
                headers: headers, 
                withCredentials:true,
                body: body,
                responseType:responseType,
            });
            console.log('final request in interceptor ', request);
            // console.log(`Added ${request.url} with ${request.body} body`)
            return next.handle(request).pipe(finalize(releaseLoader));
        }
	
}
